/**
 * A location's "Coming Soon" messages, as sent by the Locations model.
 *
 * The model always sends an array, but a page cached before a deploy can hydrate older
 * props against newer code, where the value is still a single string. Normalise both
 * shapes so a stale cache renders instead of throwing.
 */
export type ComingSoonMessages = string[] | string;

const comingSoonMessages = (messages?: ComingSoonMessages): string[] => {
	if (!messages) {
		return [];
	}
	if (typeof messages === 'string') {
		return [messages];
	}
	return messages.filter(Boolean);
};

export default comingSoonMessages;
